import type { ApolloError } from '@apollo/client';

export enum ApolloFetchPolicy {
  CACHE_FIRST = 'cache-first',
  CACHE_AND_NETWORK = 'cache-and-network',
  NETWORK_ONLY = 'network-only',
  CACHE_ONLY = 'cache-only',
  NO_CACHE = 'no-cache',
  STANDBY = 'standby',
}

export enum ApolloErrorPolicy {
  NONE = 'none',
  IGNORE = 'ignore',
  ALL = 'all',
}

export type SubscriptionResult<TData> = {
  loading: boolean;
  data?: TData | undefined;
  error?: ApolloError | undefined;
};
